import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["form", "checkBox"]
  }

  enable() {
    this.checkBoxTargets.forEach((checkBox) => {
      checkBox.checked = true
    })

    this.formTarget.requestSubmit()
  }

  disable() {
    this.checkBoxTargets.forEach((checkBox) => {
      checkBox.checked = false
    })

    this.formTarget.requestSubmit()
  }
}
